import { render, staticRenderFns } from "./Power_copy.vue?vue&type=template&id=cb2dc79c&"
import script from "./Power_copy.vue?vue&type=script&lang=js&"
export * from "./Power_copy.vue?vue&type=script&lang=js&"
import style0 from "./Power_copy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports